import React, { useState } from "react";
import ModalBox, { ModalBody, ModalHeader } from "../Modal/ModalBox";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { showToastMessage } from "../../utils";
import { TOAST_TYPE } from "../../constants";

interface SharedModelProps {
  showModal: boolean;
  closeModal: () => void;
  shareLink: string;
}

const SharedModel: React.FC<SharedModelProps> = ({
  showModal,
  closeModal,
  shareLink,
}) => {
  const [stateCopy, setStateCopy] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink);
    showToastMessage(TOAST_TYPE.SUCCESS, "Link Copied");
    setStateCopy(true);
    setTimeout(() => {
      setStateCopy(false);
    }, 3000);
  };

  return (
    <ModalBox show={showModal} closeModal={closeModal}>
      <ModalHeader>
        <div className="py-4 px-4 md:px-8 pt-10">
          <h2 className="font-semibold text-base md:text-2xl">Share</h2>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="share-modal-container px-4 md:px-8">
          <div className="flex justify-center items-center gap-6 flex-wrap">
            <div className="border border-gray-300 rounded-full p-2 flex justify-center items-center">
              <FacebookShareButton url={shareLink}>
                <FacebookIcon round={true} className="size-8 md:size-11" />
              </FacebookShareButton>
            </div>
            <div className="border border-gray-300 rounded-full p-2 flex justify-center items-center">
              <WhatsappShareButton url={shareLink}>
                <WhatsappIcon round={true} className="size-8 md:size-11" />
              </WhatsappShareButton>
            </div>
            <div className="border border-gray-300 rounded-full p-2 flex justify-center items-center">
              <TwitterShareButton url={shareLink}>
                <TwitterIcon round={true} className="size-8 md:size-11" />
              </TwitterShareButton>
            </div>
            <div className="border border-gray-300 rounded-full p-2 flex justify-center items-center">
              <LinkedinShareButton url={shareLink}>
                <LinkedinIcon round={true} className="size-8 md:size-11" />
              </LinkedinShareButton>
            </div>
          </div>

          <div className="mt-4 space-y-2 md:pb-8">
            <h2 className="font-medium text-base md:text-lg">Or copy link</h2>
            <div className="relative flex justify-start items-center">
              <input
                className="border border-gray-300 w-full py-3 px-4 rounded-l border-r-0"
                value={shareLink}
              />
              <button
                type="button"
                onClick={handleCopyLink}
                className="border border-gray-300 bg-white text-black w-28 rounded-r py-3 px-4 font-semibold outline-none text-base"
              >
                {stateCopy ? "Copied!" : "Copy!"}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </ModalBox>
  );
};

export default SharedModel;
